import CssBaseline from '@mui/material/CssBaseline'
import { ThemeProvider } from '@mui/material/styles'
import type { ReactNode } from 'react'

import { theme } from './theme'

/**
 * Installs the Skillable theme and the MUI baseline reset.
 *
 * Mounted around both the application and the "not configured" fallback in `main.tsx`, so a
 * startup failure is still rendered in the product's own type and color rather than in the
 * browser's defaults.
 *
 * `defaultMode="system"`: the app follows the operating system's light or dark setting until the
 * person picks one. MUI writes the resolved scheme to `data-theme` on `<html>`, the attribute
 * `tailwind.config.ts` also watches.
 *
 * @param props - The subtree to theme.
 * @returns The themed subtree.
 */
export function AppThemeProvider(props: { readonly children: ReactNode }) {
  return (
    <ThemeProvider theme={theme} defaultMode="system">
      <CssBaseline />
      {props.children}
    </ThemeProvider>
  )
}
